export enum SchemaModelType {
  Parent = "parent",
  Event = "event",
  Related = "related",
}
